var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeslaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 176.6 180.2",
    style: {
      enableBackground: "new 0 0 176.6 180.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E82127;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.3,178.4L113,38.9c23.6,0,31,2.5,32.1,13.1c0,0,15.8-5.9,23.8-17.9C137.8,19.6,106.6,19,106.6,19L88.3,41.3 l0,0L70.1,19c0,0-31.2,0.7-62.3,15.1c8,12.1,23.8,17.9,23.8,17.9c1.1-10.6,8.5-13.1,31.9-13.2L88.3,178.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.3,12.6c25.1-0.2,53.9,3.9,83.4,16.8c3.9-7.2,4.9-10.3,4.9-10.3C144.4,6.3,114.2,1.9,88.3,1.8 C62.3,1.9,32.2,6.3,0,19c0,0,1.4,3.9,4.9,10.3C34.4,16.5,63.2,12.4,88.3,12.6L88.3,12.6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeslaIcon);
export default __webpack_public_path__ + "static/media/tesla_icon.c4a82a038f3d67d8618e42cdbf6e7bb3.svg";
export { ForwardRef as ReactComponent };